import React from 'react';
import { cn } from './_cn';

const SegmentedToggle = ({
  value,
  onChange,
  options,
  ariaLabel,
  size = 'md',
  block = false,
  className = '',
}) => {
  const containerHeightCls =
    size === 'sm' ? 'h-8' : size === 'lg' ? 'h-11' : 'h-10';
  const sizeCls =
    size === 'sm'
      ? 'h-7 px-2.5 text-[0.65rem]'
      : size === 'lg'
        ? 'h-10 px-4 text-sm'
        : 'h-9 px-3 text-[0.72rem]';
  const iconCls = size === 'lg' ? 'h-4 w-4' : 'h-3.5 w-3.5';

  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className={cn(
        'max-w-full items-center gap-0.5 self-start rounded-md border border-slate-200 bg-slate-50 p-0.5 shadow-sm dark:border-slate-600 dark:bg-slate-800/60',
        block ? 'flex w-full' : 'inline-flex w-fit shrink-0',
        containerHeightCls,
        className,
      )}
    >
      {options.map((opt) => {
        const isActive = opt.value === value;
        const Icon = opt.icon;
        return (
          <button
            key={opt.value}
            role="radio"
            aria-checked={isActive}
            type="button"
            onClick={() => onChange(opt.value)}
            className={cn(
              'group relative inline-flex items-center gap-1.5 rounded font-semibold uppercase tracking-[0.08em] transition',
              block && 'flex-1 justify-center',
              sizeCls,
              isActive
                ? 'bg-white text-slate-900 shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:text-white dark:ring-slate-600'
                : 'text-slate-500 hover:text-slate-700 dark:text-slate-300 dark:hover:text-white',
            )}
          >
            {Icon ? (
              <Icon
                className={cn(
                  iconCls,
                  'transition',
                  isActive
                    ? 'text-blue-600 dark:text-sky-400'
                    : 'text-slate-400 group-hover:text-slate-600 dark:group-hover:text-slate-200',
                )}
                aria-hidden
              />
            ) : null}
            <span>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedToggle;
